import React from "react"

import { formatImageAlt } from "../../../shared/utils/stringUtilities";

import "./cardMember.scss"

interface CardMemberProps {
  testimony: any
}

const CardMember = (props: CardMemberProps) => {
  let { testimony } = props

  return (
    <div className="a-membercard-container">
      <div className="a-membercard-pic">
        <img src={testimony.imagenPrincipal.url} alt={formatImageAlt(testimony.imagenPrincipal.alt)} />
      </div>
      <div className="a-membercard-name">
        <p>{testimony.tituloBanner}</p>
      </div>
      <div className="a-membercard-level">
        <p>{testimony.tituloDescripcion}</p>
      </div>
    </div>
  )
}

export default CardMember
